import React from 'react';
import './BonvoyStats.css';
import OptimizedImage from './OptimizedImage';
import bonvoyMembersImg from 'url:../../assets-optimized/redesign/poweredBy/bonvoy-members.png';
import bonvoyMembersImgavif from 'url:../../assets-optimized/redesign/poweredBy/bonvoy-members.avif';
import bonvoyMembersImgwebp from 'url:../../assets-optimized/redesign/poweredBy/bonvoy-members.webp';
import targetableAudienceImg from 'url:../../assets-optimized/redesign/poweredBy/targetable-audience.png';
import targetableAudienceImgavif from 'url:../../assets-optimized/redesign/poweredBy/targetable-audience.avif';
import targetableAudienceImgwebp from 'url:../../assets-optimized/redesign/poweredBy/targetable-audience.webp';

const BonvoyStats = () => {
  return (
    <section className='redesign-bonvoy-stats'>
      <div id='bonvoy-stats-grid' className='bonvoy-stats-grid'>
        <div className='stat-card image-card members-card'>
          <OptimizedImage
            avif={bonvoyMembersImgavif}
            webp={bonvoyMembersImgwebp}
            fallback={bonvoyMembersImg}
            alt='Marriott Bonvoy Members'
            className='bg-image'
          />
          <div className='overlay'>
            <p>the industry experts in travel psychology </p>
            <div className='floating-stat-box'>
              <div className='icon-circle blue-icon'>
                <svg
                  width='63'
                  height='63'
                  viewBox='0 0 63 63'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <circle cx='31.5' cy='31.5' r='31.5' fill='#24ADE9' />
                  <g clipPath='url(#clip0_504_16867)'>
                    <path
                      d='M26.85 33.75C23.223 33.75 16 35.5886 16 39.25V42H37.7V39.25C37.7 35.5886 30.477 33.75 26.85 33.75ZM19.627 38.8571C20.929 37.9457 24.0755 36.8929 26.85 36.8929C29.6245 36.8929 32.771 37.9457 34.073 38.8571H19.627ZM26.85 31C29.8415 31 32.275 28.5329 32.275 25.5C32.275 22.4671 29.8415 20 26.85 20C23.8585 20 21.425 22.4671 21.425 25.5C21.425 28.5329 23.8585 31 26.85 31ZM26.85 23.1429C28.1365 23.1429 29.175 24.1957 29.175 25.5C29.175 26.8043 28.1365 27.8571 26.85 27.8571C25.5635 27.8571 24.525 26.8043 24.525 25.5C24.525 24.1957 25.5635 23.1429 26.85 23.1429ZM37.762 33.8443C39.56 35.1643 40.8 36.9243 40.8 39.25V42H47V39.25C47 36.0757 41.575 34.2686 37.762 33.8443ZM36.15 31C39.1415 31 41.575 28.5329 41.575 25.5C41.575 22.4671 39.1415 20 36.15 20C35.313 20 34.538 20.2043 33.825 20.55C34.8015 21.9486 35.375 23.6614 35.375 25.5C35.375 27.3386 34.8015 29.0514 33.825 30.45C34.538 30.7957 35.313 31 36.15 31Z'
                      fill='#171717'
                    />
                  </g>
                  <defs>
                    <clipPath id='clip0_504_16867'>
                      <rect width='31' height='22' fill='white' transform='translate(16 20)' />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <div className='stat-number'>271M+</div>
              <div className='stat-label'>Marriott Bonvoy members</div>
            </div>
          </div>
        </div>

        <div className='middle-column'>
          <div className='stat-card orange-card'>
            <div className='stat-number'>1.1M+</div>
            <div className='stat-label'>Travelers</div>
          </div>
          <div className='stat-card blue-card'>
            <div className='stat-number'>450K</div>
            <div className='stat-label'>Guest Rooms with Ad-Capable TV screens</div>
          </div>
        </div>

        <div className='stat-card image-card audience-card'>
          <OptimizedImage
            avif={targetableAudienceImgavif}
            webp={targetableAudienceImgwebp}
            fallback={targetableAudienceImg}
            alt='Targetable Audience Attributes'
            className='bg-image'
          />
          <div className='overlay'>
            <div className='icon-circle blue-icon'>
              <svg
                width='64'
                height='64'
                viewBox='0 0 64 64'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <circle cx='32' cy='32' r='32' fill='#24ADE9' />
                <g clipPath='url(#clip0_504_16854)'>
                  <path
                    d='M31.4994 47.0007C29.4294 47.0007 27.4794 46.6107 25.6494 45.8157C23.8194 45.0357 22.2294 43.9557 20.8794 42.6057C19.5294 41.2557 18.4644 39.6657 17.6694 37.8357C16.8894 36.0057 16.4844 34.0557 16.4844 31.9857C16.4844 29.9157 16.8744 27.9657 17.6694 26.1357C18.4644 24.3057 19.5294 22.7157 20.8794 21.3657C22.2294 20.0157 23.8194 18.9507 25.6494 18.1557C27.4794 17.3757 29.4294 16.9707 31.4994 16.9707C33.5694 16.9707 35.5194 17.3607 37.3494 18.1557C39.1794 18.9507 40.7544 20.0157 42.1194 21.3657C43.4694 22.7157 44.5344 24.3057 45.3294 26.1357C46.1094 27.9657 46.5144 29.9157 46.5144 31.9857C46.5144 34.0557 46.1244 36.0057 45.3294 37.8357C44.5344 39.6657 43.4694 41.2407 42.1194 42.6057C40.7694 43.9557 39.1794 45.0207 37.3494 45.8157C35.5194 46.6107 33.5694 47.0007 31.4994 47.0007ZM31.4994 44.0007C34.8444 44.0007 37.6794 42.8457 40.0044 40.5057C42.3294 38.1807 43.4994 35.3457 43.4994 32.0007C43.4994 28.6557 42.3444 25.8207 40.0044 23.4807C37.6794 21.1557 34.8444 20.0007 31.4994 20.0007C28.1544 20.0007 25.3194 21.1707 22.9794 23.4807C20.6544 25.8057 19.4994 28.6407 19.4994 32.0007C19.4994 35.3607 20.6694 38.1807 22.9794 40.5057C25.3044 42.8307 28.1394 44.0007 31.4994 44.0007ZM31.4994 41.0007C28.9944 41.0007 26.8794 40.1307 25.1244 38.3757C23.3694 36.6207 22.4994 34.5057 22.4994 32.0007C22.4994 29.4957 23.3694 27.3807 25.1244 25.6257C26.8794 23.8707 28.9944 23.0007 31.4994 23.0007C34.0044 23.0007 36.1194 23.8707 37.8744 25.6257C39.6294 27.3807 40.4994 29.4957 40.4994 32.0007C40.4994 34.5057 39.6294 36.6207 37.8744 38.3757C36.1194 40.1307 34.0044 41.0007 31.4994 41.0007ZM31.4994 38.0007C33.1494 38.0007 34.5594 37.4157 35.7294 36.2307C36.8994 35.0607 37.4994 33.6507 37.4994 32.0007C37.4994 30.3507 36.9144 28.9407 35.7294 27.7707C34.5594 26.6007 33.1494 26.0007 31.4994 26.0007C29.8494 26.0007 28.4394 26.5857 27.2694 27.7707C26.0994 28.9557 25.4994 30.3507 25.4994 32.0007C25.4994 33.6507 26.0844 35.0607 27.2694 36.2307C28.4394 37.4007 29.8494 38.0007 31.4994 38.0007ZM31.4994 35.0007C30.6744 35.0007 29.9694 34.7007 29.3844 34.1157C28.7994 33.5307 28.4994 32.8257 28.4994 32.0007C28.4994 31.1757 28.7994 30.4707 29.3844 29.8857C29.9694 29.3007 30.6744 29.0007 31.4994 29.0007C32.3244 29.0007 33.0294 29.3007 33.6144 29.8857C34.1994 30.4707 34.4994 31.1757 34.4994 32.0007C34.4994 32.8257 34.1994 33.5307 33.6144 34.1157C33.0294 34.7007 32.3244 35.0007 31.4994 35.0007Z'
                    fill='#fff'
                  />
                </g>
                <defs>
                  <clipPath id='clip0_504_16854'>
                    <rect width='30' height='30' fill='white' transform='translate(16.5 17)' />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <div className='stat-number'>500+</div>
            <div className='stat-label'>Targetable Audience Attributes</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BonvoyStats;
